import { valibotResolver } from '@hookform/resolvers/valibot';
import { array, nonEmpty, number, object, pipe, string } from 'valibot';

import type { IComment } from '@model/actionItem';

export const COMMENT_EDIT_FIELDS = {
  COMMENT: 'comment',
  ATTACHMENTS: 'attachments',
};

export const schemaEditComment = valibotResolver(
  object({
    [COMMENT_EDIT_FIELDS.COMMENT]: pipe(string(), nonEmpty('This field is required.')),
    [COMMENT_EDIT_FIELDS.ATTACHMENTS]: array(
      object({ extension: string(), name: string(), size: number(), url: string() }),
    ),
  }),
);

export const getCommentEditDefaultValue = (comment: IComment) => {
  return {
    [COMMENT_EDIT_FIELDS.COMMENT]: comment.comment || '',
    [COMMENT_EDIT_FIELDS.ATTACHMENTS]: comment.attachments || [],
  };
};
